import Vue from 'vue'

export default {

  state: Vue.observable({
    authenticated: false,
    user: {}
  }),
  
  setAuthenticated(auth) {
    this.state.authenticated = auth
  },

  setUser(user) {
    this.state.user = user
  },


}
